import MyProfile from "../../components/company/my-profile"

const MyProfilePage = () => {
    return <MyProfile />;
}

export default MyProfilePage;